import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//Servicios
import { ZonaService } from 'src/app/services/zona.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-nueva-zona',
  templateUrl: './nueva-zona.component.html',
  styleUrls: ['./nueva-zona.component.scss']
})
export class NuevaZonaComponent implements OnInit {

  public userLogged: any

  public zonas: any
  public loading: any
  public datosZona: any
  public instalaciones: any
  public instalacionSeleccionada: any [] = []
  public IDinstalaciones: any [] = []
  

  constructor(private apollo: Apollo, private loginService: LoginService,
    private zonaService: ZonaService, 
    private confirmacionService: ConfirmacionService, 
    private formBuilder: FormBuilder,
    private clienteService: ClienteService) { 
      this.userLogged = loginService.getUserData()
    }

  ngOnInit(): void {
    this.getZonasByCliente() 
    this.buildForm();
    this.getInstalacionesByCliente()
  }

   private buildForm(){
    this.datosZona = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      instalaciones: ['']
    });
    }

  getZonasByCliente() {
    this.apollo.watchQuery<any>({
      query: this.zonaService.getZonasByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
       /*  console.log(data) */
        this.zonas = data.cliente.zonas
        /* console.log(this.zonas) */
      });
  }

  addZona(): void {
    this.apollo.mutate<any>({
      mutation: this.zonaService.addZona(),
      variables: {
        "input": {
          "data": {
            "nombre": this.datosZona.value.nombre,
            "cliente": this.userLogged.cliente.id,
            "instalacions": this.instalacionSeleccionada,
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('CREADO', data)
      location.reload()
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  selectAllInstalaciones(e:any){
      if (e) {
        const allInstalaciones = this.instalaciones;
        allInstalaciones.forEach((instalacion:any) => {
          this.instalacionSeleccionada.push(instalacion.id)
        });   
      }else{
        this.instalacionSeleccionada = [];
      }
    }
  
    selectInstalacion(e:any){
  
      const instalacion = e.value;
      if (e.selected) {
        this.instalacionSeleccionada?.push(instalacion)
        /* console.log(this.instalacionSeleccionada) */
      }else{
        this.instalacionSeleccionada = this.instalacionSeleccionada?.filter((i:any)=> i !== instalacion) 
       /*  console.log(this.instalacionSeleccionada) */
      }
    }

  getInstalacionesByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getInstalacionesByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
       /*  console.log(data) */
        this.instalaciones = data.cliente.instalaciones
        /* console.log(this.instalaciones) */

      });
  }




  deleteZonaById(id: String){
    this.apollo.mutate({
      mutation: this.zonaService.deleteZona(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', {data})
      }, (error) => {
        console.log(error)
      })
  }


  handleClick(id: String){
    const options = {
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);
      
    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteZonaById(id)
      }
      });
  }




}
